import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #TABLE-ROW
\*------------------------------------ */
/**
 * Table row host (cat-table-row)
 */
:host {
  display: contents;
  --cat-table-row-background: var(--cat-c-table-row-background, var(--cat-theme-color-background-default));
}

/**
* Table draggable styles
*/
:host(.cat-dragging-row) {
  display: block;
  position: absolute;
  z-index: 500;
  pointer-events: none;
  opacity: 0.75;
  --cat-drag-cell-box-shadow: 0px 4px 4px 0px rgb(0 0 0 / 25%);
}
:host(.cat-dragging-row) .cat-is-expandable {
  --cat-drag-cell-box-shadow: none;
}
:host(.cat-dragging-row) .cat-c-table-row {
  --cat-table-row-background: var(--cat-theme-color-table-alternate-selected);
}

/**
 * Table row
 * 1) The main table row (tr) within the table body or table header
 * 2) specific column count is needed to the colspan to work properly.
 * 3) Apply grid column to default of 1fr for mobile view.
 */
.cat-c-table-row {
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: var(--cat-table-template-column-width, repeat(var(--cat-table-column-count, "auto-fit"), 1fr)); /* 2 */
  background-color: var(--cat-table-row-background);
  position: relative;
  overflow: visible;
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
  --cat-radio-field-color-background: transparent;
  /**
   * On the table row hover, add a background color
   */
}
.cat-c-table-row.cat-is-hovered:not(.cat-c-table-row--loader), .cat-c-table-row:focus, .cat-c-table-row:focus-visible {
  --cat-table-row-background: var(--cat-theme-color-border-subtle-hover);
  outline: none;
}
.cat-c-table-row.cat-is-row-bulkaction-selected {
  --cat-table-row-background: var(--cat-theme-color-table-alternate-selected);
}
.cat-c-table-row.cat-is-expandable:focus, .cat-c-table-row.cat-is-expandable:focus-visible {
  --cat-table-row-background: var(--cat-theme-color-background-default);
  border-block-start: 2px solid var(--cat-theme-color-border-strong);
  border-block-end: 2px solid var(--cat-theme-color-border-strong);
}

/**
 * Expandable child
 * 1) If row is expandable child, then hide the row till the parent is clicked
 */
.cat-is-expandable-child {
  opacity: 0;
  visibility: hidden;
  max-height: 0;
  overflow: hidden;
  /**
  * Expandable child active
  * 1) If row is expandable child active, then show the row
  */
}
.cat-is-expandable-child.cat-is-expandable-child-active {
  opacity: 1;
  visibility: visible;
  max-height: 100vh;
  overflow: visible;
}

/**
 * Expandable nested child
 * 1) If row is expandable nested child, then hide the row till the parent is clicked
 */
.cat-is-expandable-nested-child {
  opacity: 0;
  visibility: hidden;
  max-height: 0;
  overflow: hidden;
  /**
   * Expandable nested child active
   * 1) If row is expandable nested child active, then show the row
   */
}
.cat-is-expandable-nested-child.cat-is-expandable-child-active.cat-is-expandable-nested-child-active {
  opacity: 1;
  visibility: visible;
  max-height: 100vh;
  overflow: visible;
}

/**
 * Expandable active
 * 1) If row is expandable and active, then add borders to the top of the row
 */
.cat-is-expandable-active {
  border-block-start: 1px solid var(--cat-theme-color-border-strong);
}

/**
 * Self foldable child
 * 1) The row that contains the self foldable table header cells & cooresponding table cell content.
 */
.cat-is-self-foldable-child {
  display: block;
  width: 100%;
  /**
   * Slotted table cell in a self foldable child
   * 1) Aligns the content in a flex box that wraps.
  */
}
.cat-is-self-foldable-child ::slotted(.cat-c-table-cell) {
  display: flex;
  flex-wrap: wrap;
}
.cat-is-self-foldable-child.cat-c-table-row-empty-selffoldable {
  display: none;
}

/**
 * Disabled state
 * 1) If row is disabled, prevent clicks and change the text color to disabled
 */
.cat-is-disabled {
  pointer-events: none;
  color: var(--cat-theme-color-content-disabled);
}

/**
* Disabled cursor when table row is disabled
 */
.cat-c-table-row--disabled {
  cursor: not-allowed;
}

/**
 * Draggable hover
 * 1) On drag, add a hover state to the row before or after the dragged row
 */
.cat-is-drag-hover-before,
.cat-is-drag-hover-after {
  position: relative;
  /**
   * Prevents the before/after row hover effect, so you can clearly tell where the draggable row is being placed
   */
}
.cat-is-drag-hover-before:hover,
.cat-is-drag-hover-after:hover {
  background-color: var(--cat-table-row-background);
  /**
   * Required if draggable is used with frozen
   */
}
.cat-is-drag-hover-before:hover ::slotted(*),
.cat-is-drag-hover-after:hover ::slotted(*) {
  background-color: var(--cat-table-row-background);
}

/**
 * Draggable hover after
 * 1) On drag, add an empty row before the dragged row
 */
.cat-is-drag-hover-before {
  padding-block-start: var(--cat-table-drag-height, var(--cat-space-4x-large));
  /**
   * Visually makes a blank row
   */
}
.cat-is-drag-hover-before:before {
  content: "";
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0;
  width: 100%;
  height: var(--cat-table-drag-height, calc(var(--size-base-unit) * 6));
  background-color: var(--cat-theme-color-background-subtle-hover);
}

/**
 * Draggable hover after
 * 1) On drag, add an empty row after the dragged row
 */
.cat-is-drag-hover-after {
  padding-block-end: var(--cat-table-drag-height, var(--cat-space-4x-large));
  /**
   * Visually makes a blank row
   */
}
.cat-is-drag-hover-after:after {
  content: "";
  position: absolute;
  inset-block-end: 0;
  inset-inline-start: 0;
  width: 100%;
  height: var(--cat-table-drag-height, calc(var(--size-base-unit) * 6));
  background-color: var(--cat-theme-color-background-subtle-hover);
}
`;
       